import { tv } from '@change/ds-utils';

export const actionButton = tv({
	base: 'rounded-medium px-4 py-2',
	compoundVariants: [
		{
			// Classes to simulate the primary button from legacy DS
			class:
				'text-typography-inverse-strong! bg-[#E01A2B]! before:border-none! hover:bg-[#B71523]! before:hover:border-2! before:hover:border-solid! before:hover:border-black! active:bg-[#B71523]! before:active:border-2! before:active:border-solid! before:active:border-black!',
			actionType: 'shareExperimental',
		},
		{
			class: '*:text-size-body-small h-[36px] min-w-[104px] *:font-bold',
			variant: 'default',
		},
		{
			class: '*:text-size-body-xs h-[56px] flex-1 flex-col gap-0.5 *:leading-4',
			variant: 'square',
		},
	],
	variants: {
		variant: {
			default: '',
			square: '',
		},
		actionType: {
			edit: '',
			link: '',
			view: '',
			share: '',
			shareExperimental: '',
		},
	},
});
